import { createContext } from "react";

/** `true` once the host form has attempted a save, so each ScoringConfigPanel starts flagging its own invalid rules. */
const ScoringValidationContext = createContext(false);

export default ScoringValidationContext;
